import React, { PropTypes } from 'react';
import BillLine from './BillLine';
import Big from 'big.js';
import BillDetailModal from './BillDetailModal';
import BillRichText from './BillRichText';
import ChooseModelModal from './ChooseModelModal';
import cx from 'classnames';
import $ from 'jquery';
import Immutable from 'immutable';

const sumTotalHt = lines =>
  lines.reduce((acc, curr) => acc.plus(curr.total_ht), new Big(0)).toFixed(2);

const emptyTvaAmount = () => {
  return {
    rate: 0,
    amount: new Big(0),
  };
};

const sumTotalTva = lines => {
  return lines.reduce((result, line) => {
    const tvaValueIndex = result.findIndex(
      elt => elt.rate.toString() === line.tva_rate.toString()
    );
    let tvaValue = emptyTvaAmount();
    if (tvaValueIndex === -1) {
      tvaValue.rate = line.tva_rate;
      tvaValue.amount = new Big(line.tva_amount);
      result.push(tvaValue);
    } else {
      tvaValue = result[tvaValueIndex];
      tvaValue.amount = tvaValue.amount.plus(line.tva_amount);
    }
    return result;
  }, []);
};

const generateTvaLines = lines => {
  const tvaLines = sumTotalTva(lines);

  return tvaLines.filter(line => line.rate !== 0).map(line => (
    <tr key={`tva_${line.rate}`}>
      <th colSpan="5" />
      <th>
        <strong>Total TVA - {line.rate}%</strong>
      </th>
      <th className="fullTotalTVA">{line.amount.toFixed(2)}</th>
    </tr>
  ));
};

const sumTotalTtc = lines => {
  return lines
    .reduce((acc, curr) => acc.plus(curr.total_ttc), new Big(0))
    .toFixed(2);
};

const emptyLine = (isModel, defaultTVA) => {
  const emptyDefault = {
    label: '',
    description: '',
    quantity: '',
    unit_price_ht: '',
    tva_rate: defaultTVA,
    tva_amount: '',
    total_ht: '',
    total_ttc: '',
    accounting_code: '',
  };

  if (isModel) {
    return {
      ...emptyDefault,
      by_default: 'false',
    };
  } else {
    return emptyDefault;
  }
};

export class BillDetail extends React.Component {
  static propTypes = {
    lines: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    modelEnabled: PropTypes.bool,
    noTotal: PropTypes.bool,
    isModel: PropTypes.bool,
    beforeLinesName: PropTypes.string,
    afterLinesName: PropTypes.string,
    documentModelId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      lines: props.lines,
      modalOpened: false,
      chooseModelModalOpened: false,
      textBeforeLines: props.textBeforeLines || '',
      textAfterLines: props.textAfterLines || '',
      current: -1,
      deletedIds: [],
      tvaOptions: [],
    };

    this.onLineClick = this.onLineClick.bind(this);
    this.onNewLineClick = this.onNewLineClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onModalSave = this.onModalSave.bind(this);
    this.onDeleteLine = this.onDeleteLine.bind(this);
  }

  onLineClick(index) {
    return info => {
      this.setState({
        current: index,
        modalOpened: true,
      });
    };
  }

  onNewLineClick() {
    this.setState({
      current: this.state.lines.length,
      modalOpened: true,
    });
  }

  onModalClose() {
    this.setState({
      current: -1,
      modalOpened: false,
    });
  }

  onModalSave(index) {
    return line => {
      const newLines = this.state.lines;
      newLines[index] = line;

      this.setState({
        modalOpened: false,
        lines: newLines,
      });

      if (this.props.onChange) {
        this.props.onChange(newLines);
      }
    };
  }

  onDeleteLine(index) {
    return evt => {
      const toDelete = this.state.lines[index];
      if (toDelete.id) {
        this.state.deletedIds.splice(0, 0, toDelete.id);
      }

      this.state.lines.splice(index, 1);
      this.setState({
        lines: this.state.lines,
      });
    };
  }

  getLinesAsJson() {
    return JSON.stringify(this.getLines());
  }

  getLines() {
    return this.state.lines.map(l => ({
      ...l,
      quantity: Number(l.quantity),
      unit_price_ht: Number(l.unit_price_ht),
      tva_rate: Number(l.tva_rate),
      tva_amount: Number(l.tva_amount),
      total_ht: Number(l.total_ht),
      total_ttc: Number(l.total_ttc),
    }));
  }

  onChooseModelModalClose = () =>
    this.setState({
      chooseModelModalOpened: false,
    });

  onModelSelected = model =>
    this.setState({
      chooseModelModalOpened: false,
      textBeforeLines: model.text_before_lines,
      textAfterLines: model.text_after_lines,
    });

  onModelValueChange = field => value =>
    this.setState({
      [field]: value,
    });

  componentWillUpdate(nextProps, nextState) {
    if (this.props.onChange && this.state.tvaOptions.length > 0) {
      this.props.onChange(nextState);
    }
  }

  componentDidMount() {
    const { documentModelId } = this.props;
    // Handling choose model modal

    const chooseDocumentModelId = documentModelId
      ? documentModelId
      : '#ChooseDocumentModel';
    $(chooseDocumentModelId).on('click', () => {
      return this.setState({
        chooseModelModalOpened: true,
      });
    });

    fetch('/pco-manager/settings/tva.json')
      .then(res => res.json())
      .then(res => {
        this.setState({
          tvaOptions: res,
        });
      });
  }

  render() {
    const {
      lines,
      current,
      modalOpened,
      chooseModelModalOpened,
      textBeforeLines,
      textAfterLines,
      tvaOptions,
    } = this.state;
    const {
      readOnly,
      noTotal,
      isModel,
      beforeLinesName,
      afterLinesName,
    } = this.props;

    let currentLine = lines[current];
    let newLine = false;
    if (!currentLine) {
      const defaultTVA = () => {
        if (tvaOptions && tvaOptions.length > 0) {
          return tvaOptions[0].value;
        } else {
          return undefined;
        }
      };
      currentLine = emptyLine(isModel, defaultTVA());
      newLine = true;
    }

    const tvaOptionsWithCurrent = () => {
      if (tvaOptions.find(item => item.value === currentLine.tva_rate)) {
        return tvaOptions;
      } else {
        return Immutable.List(tvaOptions)
          .push({ value: currentLine.tva_rate, tvaOptions: tvaOptions.length })
          .toArray();
      }
    };

    const addButtonClass = cx('ui icon button create', {
      disabled: readOnly,
    });

    // const tvaLines = sumTotalTva(lines);

    const sortLines = (a, b) => a.id - b.id;

    return (
      <div>
        {!isModel && (
          <BillRichText
            label="Texte avant les lignes de prix"
            name={beforeLinesName || 'text_before_lines'}
            value={textBeforeLines}
            readOnly={readOnly}
            onChange={this.onModelValueChange('textBeforeLines')}
          />
        )}
        <table className="ui sortable table billLineList">
          <thead>
            <tr>
              <th className="one wide">
                <a className={addButtonClass} onClick={this.onNewLineClick}>
                  <i className="icon add" />
                </a>
              </th>
              <th>Libellé</th>
              <th>P.U HT</th>
              <th>Quantité</th>
              <th>Taux de TVA</th>
              <th>Montant TVA</th>
              <th>Montant TTC</th>
              {isModel && noTotal && <th>Insert. par défaut</th>}
            </tr>
          </thead>
          <tbody>
            {lines &&
              lines
                .sort(sortLines)
                .map(l => (
                  <BillLine
                    key={lines.indexOf(l)}
                    data={l}
                    readOnly={readOnly}
                    onClick={this.onLineClick(lines.indexOf(l))}
                    onDelete={this.onDeleteLine(lines.indexOf(l))}
                    isModel={isModel}
                  />
                ))}
          </tbody>
          {!noTotal && (
            <tfoot>
              <tr>
                <th colSpan="5" />
                <th>
                  <strong>Total HT</strong>
                </th>
                <th className="fullTotalHT">{sumTotalHt(lines)}</th>
              </tr>
              {generateTvaLines(lines)}
              <tr>
                <th colSpan="5" />
                <th>
                  <strong>Total TTC</strong>
                </th>
                <th className="fullTotalTTC">{sumTotalTtc(lines)}</th>
              </tr>
            </tfoot>
          )}
          <BillDetailModal
            visible={modalOpened}
            readOnly={readOnly}
            index={current}
            line={currentLine}
            newLine={newLine}
            onClose={this.onModalClose}
            onSave={this.onModalSave(current)}
            isModel={isModel}
            tvaOptions={tvaOptionsWithCurrent()}
          />
        </table>
        {!isModel && (
          <BillRichText
            label="Texte après les lignes de prix"
            name={afterLinesName || 'text_after_lines'}
            value={textAfterLines}
            readOnly={readOnly}
            onChange={this.onModelValueChange('textAfterLines')}
          />
        )}
        {!readOnly && (
          <ChooseModelModal
            isOpened={chooseModelModalOpened}
            onConfirm={this.onModelSelected}
            onClose={this.onChooseModelModalClose}
          />
        )}
      </div>
    );
  }
}

export default BillDetail;



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/BillDetail.js